export const generalKey = 'product_ps_delta_delta_3_m_p';
export const whiteLocaleList = ['jp']; //白名单
export const productPageUrl = 'delta-3-max-series-portable-power-station';
export const tabsValues = ['Product', 'Specs', 'Support', 'Bundles'];
export const productPageTheme = 'white'; //主题色

export const generalKeys = [
    {
        key: 'product_ps_delta_delta_3_m_p',
        url: 'delta-3-max-series-portable-power-station',
    },
    {
        key: 'product_ps_delta_delta_3_m',
        url: 'delta-3-max-series-portable-power-station-',
    },
];
